import styled from "styled-components/macro";

export const Container = styled.div`
  position: absolute;
  right: 8px;
  top: 12px;

  a.hotdog-dots {
    svg {
      circle {
        fill: var(--grey-0);
      }
    }

    padding: 3px 6px 6px 6px;
    border-radius: 10px;

    &:hover {
      background: var(--grey-3);
    }
  }

  .menu {
    position: absolute;
    top: 25px;
    right: -0px;
    width: 240px;
    border-radius: 10px;
    background-color: var(--menu-color);
    box-shadow: var(--default-drop-shadow);

    li {
      a {
        font-size: 18px;
        display: block;
        padding: 9px 8px;
        color: var(--grey-0);
        border-radius: 10px;

        &:hover {
          background-color: var(--menu-color-hover);
        }
      }
    }
  }
`;
